import { Route, Routes } from 'react-router-dom';
import LandingPage from '../pages/Home';
import Auth from '../pages/Auth';
import Register from '../pages/Register';
import ForgetPassword from '../pages/ForgetPassword';
import SearchMitra from '../pages/search';
import Mitra from '../pages/search/Mitra';
import OtpResetPassword from '../pages/activation/OtpResetPassword';
import ResetPassword from '../pages/activation/ResetPassword';
import ResetPasswordSuccess from '../pages/activation/ResetPasswordSuccess';
import Home from '../pages/admin';
import Account from '../pages/admin/account';
import TermOfCondition from '../pages/TermOfCondition';
import IdCard from '../pages/admin/account/IdCard';
import EditProfile from '../pages/admin/account/EditProfile';
import PrivacyPolicy from '../pages/admin/account/PrivacyPolicy';
import HelpCenter from '../pages/admin/account/HelpCenter';
import SosialMedia from '../pages/admin/account/SosialMedia';
import UploadPic from '../pages/admin/account/UploadPic';
import News from '../pages/admin/news';
import Events from '../pages/admin/events';
import Learning from '../pages/admin/learning';
import ProtectedRoute from './ProtectedRoute';
import ProtectedAuth from './ProtectedAuth';
import DetailNews from '../pages/admin/news/DetailNews';
import AllNews from '../pages/admin/news/AllNews';
import AllEvent from '../pages/admin/events/AllEvent';
import DetailEvent from '../pages/admin/events/DetailEvent';
import Chart from '../pages/admin/account/Chart';
import LearningDetail from '../pages/admin/learning/LearningDetail';
import LearningProsess from '../pages/admin/learning/LearningProsess';
import LearningPostTest from '../pages/admin/learning/LearningPostTest';
import ScanQr from '../pages/admin/qr/ScanQR';
import AttendQR from '../pages/admin/qr';
import QuestionerForm from '../pages/admin/questioner';
import QuestionerEventForm from '../pages/admin/questioner/QuestionerEventForm';
import OfflineStore from '../pages/admin/account/OfflineStore';
import OfflineStoreCreate from '../pages/admin/account/OfflineStoreCreate';
import LearningWaitingConfirm from '../pages/admin/learning/LearningWaitingConfirm';

const Router = () => {
	return (
		<Routes>
			{/* No Auth */}
			<Route
				path=""
				Component={LandingPage}
			/>
			<Route
				path="search-mitra"
				Component={SearchMitra}
			/>
			<Route
				path="search-mitra/:clientId"
				Component={Mitra}
			/>

			{/* Auth */}
			<Route
				path=""
				element={<ProtectedAuth />}
			>
				<Route
					path="auth"
					element={<Auth />}
				/>
				<Route
					path="register"
					element={<Register />}
				/>
				<Route
					path="register/:code"
					element={<Register />}
				/>
				<Route
					path="register/term-of-condition"
					element={<TermOfCondition />}
				/>
				<Route
					path="forget-password"
					element={<ForgetPassword />}
				/>
				<Route
					path="activation/reset-password/:clientId"
					element={<OtpResetPassword />}
				/>
				<Route
					path="activation/reset-password/new-password/:clientId"
					element={<ResetPassword />}
				/>
				<Route
					path="activation/reset-password/success/:clientId"
					element={<ResetPasswordSuccess />}
				/>
			</Route>

			{/* Admin */}
			<Route
				path="admin"
				element={<ProtectedRoute />}
			>
				<Route
					path=""
					element={<Home />}
				/>
				<Route path="learning">
					<Route
						path=""
						element={<Learning />}
					/>
					<Route
						path="all"
						element={<Learning />}
					/>
					<Route
						path="category/:category"
						element={<Learning />}
					/>
					<Route
						path=":slug"
						element={<LearningDetail />}
					/>
					<Route
						path="confirm/:confirm/:slug"
						element={<LearningWaitingConfirm />}
					/>
					<Route
						path="prosess/:slug"
						element={<LearningProsess />}
					/>
					<Route
						path="post-test/:learningAssetsVideoUniqueId"
						element={<LearningPostTest />}
					/>
				</Route>
				<Route path="news">
					<Route
						path=""
						element={<News />}
					/>
					<Route
						path="all"
						element={<AllNews />}
					/>
					<Route
						path=":slug"
						element={<DetailNews />}
					/>
				</Route>
				<Route path="account">
					<Route
						path=""
						element={<Account />}
					/>
					<Route
						path="id-card"
						element={<IdCard />}
					/>
					<Route
						path="edit-profile"
						element={<EditProfile />}
					/>
					<Route
						path="privacy-policy"
						element={<PrivacyPolicy />}
					/>
					<Route
						path="help-center"
						element={<HelpCenter />}
					/>
					<Route
						path="sosial-media"
						element={<SosialMedia />}
					/>
					<Route
						path="offline-store"
						element={<OfflineStore />}
					/>
					<Route
						path="offline-store/:uniqueId"
						element={<OfflineStoreCreate />}
					/>
					<Route
						path="change-profile-picture"
						element={<UploadPic />}
					/>
					<Route
						path="chart/:uniqueId"
						element={<Chart />}
					/>
				</Route>
				<Route path="events">
					<Route
						path=""
						element={<Events />}
					/>
					<Route
						path=":slug"
						element={<DetailEvent />}
					/>
					<Route
						path="all"
						element={<AllEvent />}
					/>
					<Route
						path=":id/questioner/:slug"
						element={<QuestionerEventForm />}
					/>
				</Route>
				<Route path="qr">
					<Route
						path=""
						element={<ScanQr />}
					/>
					<Route
						path=":slug"
						element={<AttendQR />}
					/>
				</Route>
				<Route path="questioner">
					<Route
						path=":slug"
						element={<QuestionerForm />}
					/>
				</Route>
			</Route>
		</Routes>
	);
};

export default Router;
